import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import PhoneInput from '../../components/PhoneInput/PhoneInput';
import { useToast } from '../../contexts/ToastContext';
import { useParticipanteService } from '../../services/participanteServices';
import { createEmptyPhoneModel, toPhonePayload } from '../../utils/phoneCountries';
import styles from './loginparticipantepage.module.css';

function RecuperarSenhaPage() {
  const { showToast } = useToast();
  const { t } = useTranslation();
  const { geraCodigoRecuperacaoParticipante } = useParticipanteService();
  const [telefone, setTelefone] = useState(() => createEmptyPhoneModel());
  const [email, setEmail] = useState('');
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState('');
  const [telefoneErro, setTelefoneErro] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErro('');
    setTelefoneErro('');

    if (!telefone.isValid) {
      setTelefoneErro(t('phoneCountry.invalid'));
      showToast(t('phoneCountry.invalid'), 3000, 'error');
      return;
    }
    if (!email.includes('@') || !email.includes('.')) {
      showToast(t('auth.invalidEmail'), 3000, 'error');
      return;
    }

    setCarregando(true);
    try {
      const resposta = await geraCodigoRecuperacaoParticipante({
        ...toPhonePayload('celular', telefone),
        email: email.trim().toLowerCase(),
      });

      if (resposta.success) {
        showToast(t('auth.recoverySent'), 4000, 'success');
      } else {
        const message = resposta.status === 503
          ? t('auth.recoveryUnavailable')
          : (resposta.message || t('auth.requestFailed'));
        setErro(message);
        showToast(message, 4000, 'error');
      }
    } catch {
      setErro(t('auth.networkError'));
      showToast(t('auth.networkError'), 3000, 'error');
    } finally {
      setCarregando(false);
    }
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{t('auth.recoverTitle')}</h2>
      <form onSubmit={handleSubmit} className={styles.form}>
        <p>{t('auth.recoverIntro')}</p>
        <PhoneInput
          value={telefone}
          onChange={setTelefone}
          label={t('phoneCountry.cellphoneLabel')}
          error={telefoneErro}
          disabled={carregando}
          required
        />
        <div className={styles.fieldGroup}>
          <label className={styles.fieldLabel} htmlFor="recovery-participant-email">{t('auth.email')}</label>
          <input
            id="recovery-participant-email"
            type="email"
            placeholder="seuemail@email.com"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            className={styles.input}
            autoComplete="email"
            required
          />
        </div>
        <button type="submit" className={styles.button} disabled={carregando}>
          {carregando ? t('auth.sendingCode') : t('auth.sendCode')}
        </button>
        {erro && <p className={styles.error}>{erro}</p>}
      </form>
    </div>
  );
}

export default RecuperarSenhaPage;
